import React from "react";
import CourierContext from ".";
import { ICourierService } from "views/admin/couriers/types/courier.interface";

type CourierProvideProps = {
  children: React.ReactNode;
};

export const CourierProvider: React.FC<CourierProvideProps> = ({
  children,
}) => {
  const [services, setServices] = React.useState<ICourierService[]>([]);

  const value = {
    services,
    setServices,
  };

  return (
    <CourierContext.Provider value={value}>{children}</CourierContext.Provider>
  );
};
